import { useState } from "react";
import {
    Badge,
    Table,
    Text,
    Menu,
    Box,
    Flex,
} from "@chakra-ui/react";

import {
    MoreVertical,
    Eye,
} from "lucide-react";

import {
    useSelector,
} from "react-redux";

import {
    useNavigate,
} from "react-router-dom";

import DataTable from "../../../components/DataTable";
import TicketDetailsDrawer from "./ViewTicketDrawer";
import EmptyState from "../../../components/EmptyState";

const columns = [
    {
        key: "ticket_id",
        label: "Ticket ID",
    },
    {
        key: "category",
        label: "Category",
    },
    {
        key: "subject",
        label: "Subject",
    },
    {
        key: "status",
        label: "Status",
    },
    {
        key: "updated_at",
        label: "Last Updated",
    },
    {
        key: "actions",
        label: "Actions",
        align: "center",
    },
];

const statusColor = {
    OPEN: "blue",
    IN_PROGRESS: "orange",
    RESOLVED: "green",
    CLOSED: "gray",
};

const TicketsTable = () => {
    const navigate =
        useNavigate();
    const [selectedTicket, setSelectedTicket] =
    useState(null);

    const [drawerOpen, setDrawerOpen] =
    useState(false);

    const {
        tickets = [],
        loading,
    } = useSelector(
        (state) =>
            state.support
    );

    const formatDate = (
        date
    ) => {
        if (!date)
            return "-";

        return new Date(
            date
        ).toLocaleDateString(
            "en-GB",
            {
                day: "numeric",
                month: "short",
                year: "numeric",
            }
        );
    };

    return (
        <>
        <DataTable
            title="Recent Tickets"
            total={
                tickets.length
            }
            data={tickets.slice(
                0,
                3
            )}
            columns={columns}
            pageSize={3}
            loading={
                loading
            }
            emptyComponent={
                        <EmptyState
                            imageSize="180px"
                            title="No Support Tickets"
                            message="You haven't submitted any support tickets yet. Your support requests will appear here once they're created."
                            py={12}
                        />
                    }
            rightAction={
                <Text
                    color="#2453FF"
                    fontWeight="600"
                    fontSize="sm"
                    cursor="pointer"
                    onClick={() =>
                        navigate(
                            "/support/tickets"
                        )
                    }
                >
                    View All Tickets →
                </Text>
            }
            renderRow={(
                ticket
            ) => (
                <Table.Row
                    key={
                        ticket.ticket_id
                    }
                >
                    <Table.Cell>
                        <Text
                            fontWeight="600"
                        >
                            #
                            {ticket.ticket_id?.slice(
                                0,
                                8
                            )}
                        </Text>
                    </Table.Cell>

                   <Table.Cell maxW="220px">
    <Text
        textTransform="capitalize"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        title={ticket.category
            ?.replaceAll("_", " ")
            .toLowerCase()}
    >
        {ticket.category
            ?.replaceAll("_", " ")
            .toLowerCase()}
    </Text>
</Table.Cell>

                   <Table.Cell maxW="300px">
    <Text
        fontWeight="500"
        whiteSpace="nowrap"
        overflow="hidden"
        textOverflow="ellipsis"
        title={ticket.subject}
    >
        {ticket.subject}
    </Text>
</Table.Cell>

                    <Table.Cell>
                        <Badge
                            colorPalette={
                                statusColor[
                                    ticket
                                        .status
                                ] ||
                                "gray"
                            }
                            borderRadius="full"
                            px={3}
                        >
                            {
                                ticket.status
                            }
                        </Badge>
                    </Table.Cell>

                    <Table.Cell>
                        {formatDate(
                            ticket.updated_at
                        )}
                    </Table.Cell>
                    <Table.Cell textAlign="center">
    <Menu.Root
        positioning={{
            placement:
                "bottom-end",
        }}
    >
        <Menu.Trigger
            asChild
        >
            <Box
                cursor="pointer"
                display="flex"
                alignItems="center"
                justifyContent="center"
                w="32px"
                h="32px"
                borderRadius="8px"
                _hover={{
                    bg: "gray.100",
                }}
            >
                <MoreVertical
                    size={16}
                    color="#64748B"
                />
            </Box>
        </Menu.Trigger>

        <Menu.Positioner>
            <Menu.Content
                minW="180px"
                bg="white"
                border="1px solid"
                borderColor="#E2E8F0"
                borderRadius="12px"
                p="6px"
                shadow="xl"
            >
                <Menu.Item
                    value="view"
                    px="12px"
                    py="10px"
                    borderRadius="8px"
                    cursor="pointer"
                    onClick={() => {
    setSelectedTicket(ticket);
    setDrawerOpen(true);
}}
                >
                    <Flex
                        align="center"
                        gap={3}
                    >
                        <Eye
                            size={16}
                            color="#475569"
                        />

                        <Text
                            fontSize="14px"
                            fontWeight="500"
                            color="#0F172A"
                        >
                            View Ticket
                        </Text>
                    </Flex>
                </Menu.Item>
            </Menu.Content>
        </Menu.Positioner>
    </Menu.Root>
</Table.Cell>
                </Table.Row>
            )}
            
        />
        <TicketDetailsDrawer
    ticket={selectedTicket}
    open={drawerOpen}
    onClose={() =>
        setDrawerOpen(false)
    }
/>
        </>
    );
};

export default TicketsTable;